<div class="watch-on-container">
  <div>
    <h1>Watch on your TV</h1>
    <div class="logos">
      <div class="logo">
        <img alt="chrome cast logo" class="chrome-cast" src="/assets/air_chromecast.png"/>
      </div>
      <div class="logo">
        <img alt="airplay logo" src="/assets/airplay.png"/>
      </div>
      <div *ngIf="exposeAppleTV" class="logo">
        <img alt="apple TV logo" src="/assets/apple-tv-logo.png"/>
      </div>
      <div *ngIf="exposeAndroidTV" class="logo">
          <img alt="apple TV logo" src="/assets/android-tv-logo_fit.png"/>
        </div>
    </div>
  </div>
  <!-- <div class="see-all">See All Supported Platforms</div> -->
</div>